export default __webpack_public_path__ + "static/media/icon-chervron-down.77a78805.svg";